import styled from "styled-components"
import StyledLink from "~/components/UI/Link"
import { useMemo, useCallback, useEffect } from "react"
import { useTranslation } from "~/i18n"
import Text from "~/components/Text"
// import Icon from "~/components/UI/Icon"
import { useRouter } from "next/router"
import { ROUTES } from '~/constant'
import $ from 'jquery'
import signOut from "~/utils/authenticated"
import Link from 'next/link'

const MyContainer = styled.div`
  position: relative;
  padding-bottom: 8px;
  :hover {
    cursor: pointer;
  }
`

const MenuContainer = styled.div`
  right: 0;
  top: 50px;
  position: absolute;
  width: 250px;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 10px 0 rgba(0, 85, 255, 0.24);
  background-color: #ffffff;
  display: none;
`

const LinkItem = styled(StyledLink)`
  display: block;
  padding: 15px;
  background-color: #fff;
  transition: 200ms;
  font-weight: normal;
  :hover {
    background-color: #ebf3ff;
  }

  &.more-menu-item-active {
    background-color: #ebf3ff;
    font-weight: bold;
  }
`

const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(0, 85, 255, 0.24);
`

interface Props {
  onclick?: any, separator?: boolean, link: string, text: string
  color?: string
}
const getMenu = (t: any): Array<Props> => ([
  { text: t`Danh sách đầu tư của tôi`, link: ROUTES.MY_INVESTMENTS },
  { text: t`Quản lý Mua / Bán`, link: ROUTES.TRADING_ORDERS },
  { separator: true, text: '', link: '' },
  { text: t`Tài khoản`, link: ROUTES.UPDATE_PROFILE },
  { text: t`Xác thực`, link: ROUTES.VERIFY_IDENTITY },
  { text: t`Mời bạn bè`, link: ROUTES.INVITE_OTHERS },
  { text: t`Áp dụng mã giới thiệu`, link: ROUTES.REFERRAL },
])

const MenuItem: React.FC<Props> = ({ onclick, link, text, color }) => {
  const router = useRouter()
  return (
    <Link href={link}>
      <LinkItem
        onClick={onclick}
        className={router.pathname === link ? 'more-menu-item-active' : ''}
      >
        <Text style={{ color: color || '#000' }}>
          {text}
        </Text>
      </LinkItem>
    </Link>
  )
}

const UserMenu = () => {
  const [t] = useTranslation()
  const router = useRouter()
  const menu = useMemo(() => getMenu(t), [t])
  const signout = useCallback((evt: any) => {
    evt.preventDefault()
    signOut({ withSignOutMutation: true })
  }, [])

  const menuItems = useMemo(() => {
    return menu.map((item, index) => {

      if (item.separator) {
        return <Separator key={index} />
      }

      return (
        <MenuItem key={item.link} {...item} />
      )
    })
  }, [menu, router])

  const handleOpenMenu = useCallback(() => {
    let timer: number
    const el = $('.user-menu')
    const content = $('.user-menu-content')
    if (el) {
      el.hover(() => {
        clearTimeout(timer)
        if (content) {
          content.fadeIn(150)
        }
      }, () => {
        timer = setTimeout(() => {
          if (content) {
            content.fadeOut(150)
          }
        }, 100);
      })
    }
  }, [])

  useEffect(() => {
    handleOpenMenu()
    return () => {
      $('.user-menu').off('hover')
    }
  }, [handleOpenMenu])

  return (
    <MenuContainer className='user-menu user-menu-content'>
      {menuItems}
      <Separator />
      <MenuItem
        link=''
        text={t`Đăng xuất`}
        color='#ff5a5f'
        onclick={signout}
      />
    </MenuContainer>
  )
}

export default UserMenu
